import { render, staticRenderFns } from "./PointPositionManage.vue?vue&type=template&id=447606f1&scoped=true&"
import script from "./PointPositionManage.vue?vue&type=script&lang=js&"
export * from "./PointPositionManage.vue?vue&type=script&lang=js&"
import style0 from "./PointPositionManage.vue?vue&type=style&index=0&id=447606f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447606f1",
  null
  
)

export default component.exports